var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callToAction"},[_c('v-icon',{staticClass:"rounded-icon",attrs:{"color":"#DA4453","font-size":"4em","size":"2em"}},[_vm._v(_vm._s(_vm.icon))]),_c('div',{staticClass:"text"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }